import { useEffect, useState } from "react";

/**
 * Seconds remaining until `sinceTimestamp + intervalMs`, ticking down once a
 * second. Resets automatically whenever sinceTimestamp advances (e.g. a
 * TanStack Query refetch - manual or scheduled - updates dataUpdatedAt).
 */
export function useCountdown(sinceTimestamp: number | undefined, intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!sinceTimestamp) return Math.round(intervalMs / 1000);
  const remainingMs = sinceTimestamp + intervalMs - now;
  return Math.max(0, Math.ceil(remainingMs / 1000));
}
